import { fetch } from '@/utils/fetch';

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryPoints(storyId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/story-points/list/${storyId}`,
    method: 'get',
  });
}

/**
 * 根据 id 添加 Point
 * @returns {Promise<Response>}
 */
export function _addPoints(storyId, data) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/story-points/add/${storyId}`,
    method: 'post',
    data: data
  });
}

/**
 * 删除 goodsPoint
 * @returns {Promise<Response>}
 */
export function _deletePoints(relationId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/story-points/delete/${relationId}`,
    method: 'post',
  });
}

export default {};
